import { Site, Upload } from '../../../../../../types';
import { v4 as uuidv4 } from 'uuid';
import { UploadType } from '../../../../../../consts/uploadType';
import { UploadData } from '../../../../../../store/uploadStore';

/**
 * Generates uploadStore representation of the upload
 * Example backend response (the backend doesn't return photos array here for some reason!)
 * {
 *   "upload": {
 *     "id": "67ceb399fcd457e9a6a1da44",
 *     "pilot": "d.kunichnik+pilot@traceair.net",
 *     "customer": "phi",
 *     "site": "amoruso-ranch",
 *     "date": "2024-11-13",
 *     "state": "NEW",
 *     "uri": "",
 *     "viaExpDistro": false,
 *     "flightScheduleId": "recdtay82PFFFSEsR",
 *     "georef": ""
 *   }
 * }
 */
export const generateUploadDataStateFromCreateResponse = (
  uploadType: UploadType,
  response: Upload,
  abortController: AbortController,
  site: Site,
): UploadData => {
  const { uri } = response;

  if (!uri) {
    throw new Error('The upload is missing the URI. Please, reload the page and start over.');
  }

  return {
    upload: {
      ...response,
      uri,
      photos: [],
    },
    overview: {
      date: response.date,
      state: response.state,
      uri,
      photosCount: { uploaded: 0, all: 0 },
      isOwnUpload: true,
      flightScheduleId: response.flightScheduleId,
    },
    queue: [],
    meta: {
      abortController,
      site,
      type: uploadType,
      restoringUpload: false,
      currentBatch: -1,
      isPreviouslyCompleted: false,
    },
  };
};
